import React, { Component } from "react";
import { connect } from "react-redux";
import tinycolor from "tinycolor2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { toggleChat } from "../../actions/app";
import { ShakeButton } from "./shakeAnimation-desk";
import { BlinkButton } from "./blinkAnimation-desk";
import CloseButton from "./chat-button-close";
import { SliderContainer } from "./ChatSliderContainerStyled";


class ChatButtonDesktop extends Component {
  constructor (props) {
    super(props)
    this.state = ({
      showButton: true,
      slideSpanTextWidth: 0,
      whichConfig: 'desktop'

    })
  }
  slideSpanTextElementRef = React.createRef()

  iconSize = "lg";
  buttonAnimationClass = "";
  slideBarSide;
  closeButtonSide;
  addClasse;
  removeClasse;
  removeSetTimeOut;
	static getDerivedStateFromProps(props, state) {
		return {
			whichConfig: props.isMobile ? "mobile" : "desktop"
		}
	}
  componentDidMount() {
    if (this.slideSpanTextElementRef.current) {
      const elementWidth = this.slideSpanTextElementRef.current.getBoundingClientRect().width;
      this.setState({ slideSpanTextWidth: elementWidth })
    }
  }
  componentWillUnmount() {
    this.clearIntervals();
  }

  getButtonCustomIcon = (floatingButtonIconUrl) => {
    return {
      backgroundImage: `url(${floatingButtonIconUrl})`,
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
    };
  };

  getButtonShape = (shape) => {
    const { buttonBorderRadiusPx, buttonHeight, buttonWidth } = this.props.config[this.state.whichConfig]
    switch (shape) {
      case "roundBorder":
        return {
          borderRadius: `${buttonBorderRadiusPx}px`,
          height: `${buttonHeight}px`,
          width: `${buttonWidth}px`,
        };

      case "circle":
        return {
          borderRadius: "50%",
          height: `${buttonHeight}px`,
          width: `${buttonWidth}px`,
        };
      // square
      default:
        return {
          height: `${buttonHeight}px`,
          width: `${buttonWidth}px`,
        };
    }
  };

  getSlideContainerShape = (shape) => {
    const { buttonBorderRadiusPx, buttonHeight, buttonWidth } = this.props.config[[this.state.whichConfig]]
    switch (shape) {
      case "roundBorder":
        return {
          borderRadius: `${buttonBorderRadiusPx}px`,
          height: `${buttonHeight}px`,
          width: `${buttonWidth}px`,
        };

      case "circle":
        return {
          borderRadius: "200px",
          height: `${buttonHeight}px`,
          width: `${buttonWidth}px`,
        };
      // square
      default:
        return {
          height: `${buttonHeight}px`,
          width: `${buttonWidth}px`,
        };
    }
  };

  getButtonPosition = (position) => {
    switch (position) {
      case "sideviewRight":
        this.slideBarSide = { right: 0 };
        this.closeButtonSide = { right: 0 };
        return {
          pointerEvents: "none",
          position: "fixed",
          bottom: "50%",
          right: 0,
        };
      case "sideviewLeft":
        this.slideBarSide = { left: 0 };
        this.closeButtonSide = { left: 0 };
        return {
          pointerEvents: "none",
          position: "fixed",
          bottom: "50%",
          left: 0,
        };
      case "bottonLeft":
        this.slideBarSide = { left: 0 };
        this.closeButtonSide = { left: 0 };
        return {
          pointerEvents: "none",
          position: "fixed",
          bottom: 0,
          left: 0,
        };
      // bottonRight
      default:
        this.slideBarSide = { right: 0 };
        this.closeButtonSide = { right: 0 };
        return {
          pointerEvents: "none",
          position: "fixed",
          bottom: 0,
          right: 0,
        };
    }
  };

  getSlideAnimation = () => {
    const { buttonAnimationInitTime } = this.props.config[this.state.whichConfig];
    const initTime = buttonAnimationInitTime
      ? buttonAnimationInitTime
      : "0";
    this.buttonAnimationClass = "omni-button-slide";
    return {
      animationName: "slide",
      animationDuration: "4s",
      animationTimingFunction: "linear",
      animationIterationCount: 1,
      animationDelay: `${initTime}s`,
    };
  };

  getButtonStyle = () => {
    const { 
      floatingButtonIconUrl,
      buttonShape,
      buttonBorderColor,
      buttonBackgroundColor,
      buttonMarginRight,
      buttonMarginLeft,
      buttonMarginBottom
    } = this.props.config[this.state.whichConfig];
    const customIcon = floatingButtonIconUrl
      ? this.getButtonCustomIcon(
        floatingButtonIconUrl
      )
      : "";
    const shape = buttonShape
      ? buttonShape.trim()
      : "";
    const dktStyle = {
      pointerEvents: "auto",
      cursor: "pointer",
      backgroundColor: tinycolor(
        buttonBackgroundColor
      ),
      border: `2px solid ${tinycolor(buttonBorderColor)}`,
      marginRight: `${buttonMarginRight}px`,
      marginLeft: `${buttonMarginLeft}px`,
      marginBottom: `${buttonMarginBottom}px`,
      ...this.getButtonShape(shape),
      ...customIcon,
    };
    return dktStyle;
  };

  getButtonSlideStyle = () => {
    const { floatingButtonIconUrl, buttonShape, buttonBorderColor, buttonBackgroundColor } = this.props.config[this.state.whichConfig];
    const customIcon = floatingButtonIconUrl
      ? this.getButtonCustomIcon(
        floatingButtonIconUrl
      )
      : "";
    const shape = buttonShape
      ? buttonShape.trim()
      : "";
    return {
      cursor: "pointer",
      backgroundColor: tinycolor(buttonBackgroundColor),
      border: `2px solid ${tinycolor(buttonBorderColor)}`,
      display: "block",
      position: "absolute",
      top: 0,
      ...this.slideBarSide,
      ...this.getButtonShape(shape),
      ...customIcon,
    };
  };


  clearIntervals = () => {
    clearInterval(this.addClasse);
    clearInterval(this.removeClasse);
    clearInterval(this.removeSetTimeOut);
  };

  handleClick = (e) => {
    this.clearIntervals();
    this.props.open();
  };

  handleMouseEnter = () => {
    if(!this.state.showButton) {
      this.setState({showButton: true})
    }
  }

  getSpanTextStyle = () => {
    const { position, buttonWidth} = this.props.config[this.state.whichConfig];
    if (
      position === "sideviewLeft" ||
      position === "bottonLeft"
    ) {
      const marginLeft = `${parseInt(buttonWidth) + 2
        }`;
      return {
        paddingRight: "8px",
        paddingLeft: "6px",
        marginLeft: `${marginLeft.toString()}px`,
        whiteSpace: "nowrap",
        width: "75%",
        overflow: " hidden",
        textOverflow: "ellipsis",
      };
    } else {
      return {
        paddingLeft: "8px",
        paddingRight: "6px",
        whiteSpace: "nowrap",
        marginRight: `${buttonWidth}px`,
        width: "75%",
        overflow: " hidden",
        textOverflow: "ellipsis",
      };
    }
  };

  renderSlideButton = () => {
    const {
      buttonAnimation,
    } = this.props.config;
    const {
      buttonShape,
      buttonBackgroundColor,
      buttonMarginRight,
      buttonMarginLeft,
      buttonMarginBottom,
      buttonHeight,
      buttonAnimationInitTime,
      buttonWidth,
      buttonAnimationText,
      floatingButtonIconUrl
    } = this.props.config[this.state.whichConfig];
    console.log(this.props.config)
    const shapeStyles = this.getSlideContainerShape(
      buttonShape ? buttonShape.trim() : ""
    );
    const spanTextWidthPlusButtonWidth = parseInt(buttonWidth) + parseInt(this.state.slideSpanTextWidth);
    const animationDelay = buttonAnimationInitTime || 0;
    return (
      <SliderContainer
        backgroundColor={buttonBackgroundColor}
        marginRight={buttonMarginRight}
        marginLeft={buttonMarginLeft}
        marginBottom={buttonMarginBottom}
        buttonHeight={buttonHeight}
        animation={buttonAnimation}
        animationDelay={animationDelay}
        slideSpanTextWidth={spanTextWidthPlusButtonWidth}
        shapeStyles={shapeStyles}
        className={`omni-container-slider ${
          buttonAnimation ? "omni-button-slide" : ""
        }`}
        onClick={this.handleClick}
        isMobile={this.props.isMobile}
      >
        <span
          ref={this.slideSpanTextElementRef}
          style={this.getSpanTextStyle()}
          className="span-text"
        >
          {buttonAnimationText}
        </span>
        <div>
          <button
            id="omni-show-chat"
            title="Converse com a assistente virtual"
            onClick={this.handleClick}
            style={this.getButtonSlideStyle()}
          >
            {floatingButtonIconUrl ? (
              <></>
            ) : (
              <FontAwesomeIcon
                icon={faComments}
                size={this.iconSize}
                className="chat-icon"
              />
            )}
          </button>
        </div>
      </SliderContainer>
    );
  };

  renderShakeButton = () => {
    const { floatingButtonIconUrl } = this.props.config[this.state.whichConfig];
    this.animateRepetition();
    return (
      <ShakeButton
        config={this.props.config}
        id="omni-show-chat"
        onClick={this.handleClick}
        style={this.getButtonStyle()}
      >
        {floatingButtonIconUrl ? (
          <></>
        ) : (
          <FontAwesomeIcon
            icon={faComments}
            size={this.iconSize}
            className="chat-icon"
          />
        )}
      </ShakeButton>
    );
  };

  renderBlinkButton = () => {
    const { floatingButtonIconUrl } = this.props.config[this.state.whichConfig];
    this.animateRepetition();
    return (
      <BlinkButton
        config={this.props.config}
        id="omni-show-chat"
        onClick={this.handleClick}
        style={this.getButtonStyle()}
      >
        {floatingButtonIconUrl ? (
          <></>
        ) : (
          <FontAwesomeIcon
            icon={faComments}
            size={this.iconSize}
            className="chat-icon"
          />
        )}
      </BlinkButton>
    );
  };

  renderButton = () => {
    const { floatingButtonIconUrl } = this.props.config[this.state.whichConfig];
    return (
      <button
        config={this.props.config}
        id="omni-show-chat"
        onClick={this.handleClick}
        style={this.getButtonStyle()}
      >
        {floatingButtonIconUrl ? (
          <></>
        ) : (
          <FontAwesomeIcon
            icon={faComments}
            size={this.iconSize}
            className="chat-icon"
          />
        )}
      </button>
    );
  };

  animateRepetition = () => {
    const { buttonAnimationRepetitionEnable, buttonAnimationInitTime, buttonAnimationRepetitionInterval } = this.props.config[this.state.whichConfig];
    if (buttonAnimationRepetitionEnable) {
      let init =
        parseInt(buttonAnimationInitTime) * 1000;
      let rept =
        parseInt(buttonAnimationRepetitionInterval) *
        1000;
      let animationClass;
      let timer = init + rept + 50;
      let addTime = 0;
      let deletetime = 0;      
      this.removeSetTimeOut = setTimeout(() => {
        animationClass = document
          .getElementById("omni-show-chat")
          .classList.item(1);
        document
          .getElementById("omni-show-chat")
          .classList.remove(animationClass);

        addTime = rept + 100;
        this.addClasse = setInterval(() => {
          document
            .getElementById("omni-show-chat")
            .classList.add(animationClass);
        }, addTime);

        deletetime = addTime + rept;
        this.removeClasse = setInterval(() => {
          animationClass = document
            .getElementById("omni-show-chat")
            .classList.item(1);
          document
            .getElementById("omni-show-chat")
            .classList.remove(animationClass);
        }, deletetime);
      }, timer);
    }
  };

  render() {
    const { buttonAnimationRepetitionEnable, buttonAnimationType, position } = this.props.config[this.state.whichConfig];
    const decideToShowButtonIfIsDesktop = this.props.isMobile ? true : this.state.showButton
    return (
      <div
        id="omni-hide-chat-button"
        style={this.getButtonPosition(position)}
        onMouseEnter={this.handleMouseEnter}
      >
          {buttonAnimationRepetitionEnable ? buttonAnimationType === "slide"
            ? this.renderSlideButton()
            : buttonAnimationType === "shake"
              ? this.renderShakeButton()
              : this.renderBlinkButton() : this.renderButton()}
          {this.props.config.isWebChannelExit && 
            <CloseButton 
              width={18} height={18} 
              closeButtonSide={this.closeButtonSide}
              showButton={decideToShowButtonIfIsDesktop}
              clearIntervals={this.clearIntervals}
            />
          }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  config: state.config,
});

const mapDispatchToProps = (dispatch) => ({
  open: () => dispatch(toggleChat(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatButtonDesktop);
